import React from 'react';
import { Section, FadeIn } from './ui';
import { HotelIcon, MapIcon, BriefcaseIcon, UsersIcon, MicIcon } from 'lucide-react';
export function UseCases() {
  const cases = [{
    icon: <HotelIcon className="w-6 h-6" data-id="element-7423" />,
    title: 'Hotels and Resorts',
    desc: 'Turn meeting space and room blocks into higher-value retreat packages.'
  }, {
    icon: <MapIcon className="w-6 h-6" data-id="element-7424" />,
    title: 'DMCs',
    desc: 'Add a premium experience layer beyond logistics.'
  }, {
    icon: <BriefcaseIcon className="w-6 h-6" data-id="element-7425" />,
    title: 'MICE Planners',
    desc: 'Create better agendas, stronger engagement, and cleaner reporting.'
  }, {
    icon: <UsersIcon className="w-6 h-6" data-id="element-7426" />,
    title: 'Corporate HR Teams',
    desc: 'Make offsites more meaningful, measurable, and easier to justify.'
  }, {
    icon: <MicIcon className="w-6 h-6" data-id="element-7427" />,
    title: 'Retreat Facilitators',
    desc: 'Use intake, prompts, and reporting to make sessions more personalized and professional.'
  }];
  return <Section id="use-cases" className="bg-brand-navy text-white" data-id="element-7428">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-7429">
        <FadeIn data-id="element-7430">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-7431">
            Built for the people who run group experiences.
          </h2>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7432">
        {cases.map((uc, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-7433">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 h-full hover:bg-white/10 transition-colors" data-id="element-7434">
              <div className="bg-brand-teal/20 text-brand-teal w-12 h-12 rounded-xl flex items-center justify-center mb-5" data-id="element-7435">
                {uc.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-7436">{uc.title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-7437">{uc.desc}</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}